<div class="adx-keypad-dialog-wrapper">
  <div class="adx-keypad-dialog">
    <!-- Header -->
    <div class="adx-settings-header">
      <h2 class="adx-settings-title">{{ 'ASTIMAX.PHONE.WIDGET.KEYPAD.TOGGLE' | translate }}</h2>
      <button mat-icon-button class="adx-settings-close-btn" (click)="close()">
        <fa-icon [icon]="faXmark"></fa-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="adx-keypad-content">
      <!-- Number Input -->
      <mat-form-field appearance="outline" class="adx-keypad-input">
        @if (!hasActiveCall) {
          <mat-label>{{ 'ASTIMAX.PHONE.WIDGET.CALL.TARGET.ENTER_NUMBER' | translate }}</mat-label>
        }
        @if (hasActiveCall) {
          <mat-label>{{ 'ASTIMAX.PHONE.WIDGET.KEYPAD.ENTER_DIGITS' | translate }}</mat-label>
        }
        <input matInput [(ngModel)]="targetNumber" type="tel" autocomplete="tel" (blur)="onTargetNumberBlur()" [disabled]="hasActiveCall" #numberInput>
        @if (targetNumber) {
          <button matSuffix mat-icon-button (click)="targetNumber=''">
            <fa-icon [icon]="faTimes"></fa-icon>
          </button>
        }
        @if (!targetNumber && lastDialedNumber) {
          <button matSuffix mat-icon-button (click)="redialLastNumber()" matTooltip="{{ 'ASTIMAX.PHONE.WIDGET.CALL.TARGET.REDIAL_LAST_NUMBER' | translate }}">
            <fa-icon [icon]="faRedoAlt"></fa-icon>
          </button>
        }
      </mat-form-field>

      <!-- Keypad Grid -->
      <div class="adx-keypad-grid">
        @for (row of keypadKeys; track $index) {
          @for (key of row; track key) {
            <button class="adx-keypad-button" (click)="onKeypadPress(key)">{{ key }}</button>
          }
        }
      </div>

      <!-- Bottom Row -->
      @if (!hasActiveCall) {
        <div class="adx-keypad-bottom-row">
          <button class="adx-keypad-call-button" [disabled]="!targetNumber" (click)="startCall()">
            <fa-icon [icon]="faPhone"></fa-icon>
          </button>
          <button class="adx-keypad-backspace-button" [disabled]="!targetNumber" (click)="onKeypadBackspace()">
            <fa-icon [icon]="faBackspace"></fa-icon>
          </button>
        </div>
      }
      @if (hasActiveCall) {
        <div class="adx-keypad-bottom-row hangup">
          <button mat-raised-button class="warn adx-keypad-hangup-button" (click)="endCall()">
            <fa-icon [icon]="faPhoneSlash"></fa-icon>
          </button>
        </div>
      }
    </div>
  </div>
</div>
